document.querySelectorAll('.btn').forEach(btn => {
  const text = btn.querySelector('.btn-text');
  btn.style.setProperty('--text-width', text.offsetWidth + 'px');
});

// magnet effect

const magnets = document.querySelectorAll('.bb-excellence');
const strength = 50;

magnets.forEach(magnet => {
  magnet.addEventListener('mousemove', e => moveMagnet(e, magnet));
  magnet.addEventListener('mouseleave', () => resetMagnet(magnet));
});

function moveMagnet(event, magnet) {
  const rect = magnet.getBoundingClientRect();

  const x = ((event.clientX - rect.left) / magnet.offsetWidth - 0.5) * strength;
  const y = ((event.clientY - rect.top) / magnet.offsetHeight - 0.5) * strength;

  magnet.style.transform = `translate(${x}px, ${y}px)`;
}

function resetMagnet(magnet) {
  magnet.style.transform = `translate(0px, 0px)`;
}

